import { createFileRoute } from "@tanstack/react-router";
import {
  aiBlogPageJsonLd,
  aiBlogRouteHead,
} from "@/lib/ai-blogging-seo";
import { founderPersonJsonLd, landingOrganizationJsonLd } from "@/lib/landing-seo";
import { jsonLdScript } from "@/lib/marketing-jsonld";
import { LANDING } from "@/content/marketing";
import { AiTools } from "@/components/landing/AiTools";
import { Destinations } from "@/components/landing/Destinations";
import { FinalCta } from "@/components/landing/FinalCta";
import { Hero } from "@/components/landing/Hero";
import { PricingTeaser } from "@/components/landing/PricingTeaser";
import { Proof } from "@/components/landing/Proof";
import { PublishFlow } from "@/components/landing/PublishFlow";
import { BlogShowcase } from "@/components/landing/BlogShowcase";
import { WhoFor } from "@/components/landing/WhoFor";
import "@/styles/landing-story.css";

// The original AI-first homepage now lives at its own public URL.
export const Route = createFileRoute("/_home/ai-blogging-platform")({
  ssr: true, // public SEO route (D-216-5)
  head: aiBlogRouteHead,
  component: AiBloggingPage,
});

function AiBloggingPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(aiBlogPageJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(landingOrganizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(founderPersonJsonLd) }}
      />
      {/* The page needs a top-level landmark so assistive tech can skip the
          nav (#416). The layout's SiteFooter is a sibling of this <main>, so
          the contentinfo landmark survives. */}
      <main className="gs-landing-story">
        <Hero />
        <BlogShowcase />
        <PublishFlow />
        <AiTools />
        <Destinations />
        <Proof />
        <PricingTeaser />
        <WhoFor />
        <FinalCta content={LANDING.finalCta} secondary="skill" />
      </main>
    </>
  );
}
